import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@chakra-ui/react';
/**
 * A line of quiet words that opens or reveals something: the trace summary,
 * "Comment est calculé…", "Voir les 6". A plain Button on the `agent`
 * palette, so it carries the dashboard's focus ring and a 32px target.
 */
export function TextToggle(props) {
    return (_jsx(Button, { colorPalette: "agent", variant: "plain", size: "xs", alignSelf: "flex-start", px: "0", gap: "1.5", textStyle: "agent.label", color: "agent.fgMuted", _hover: { color: 'agent.fgBody' }, 
        // One notch under the recipe's 16px: these icons sit inside a line of text.
        _icon: { boxSize: '3.5' }, ...props }));
}
